import { TUser } from 'types/user';

export const isDisplayAskEmailForm = (user: TUser | undefined): boolean =>
    Boolean(user?.isAuthenticated && !user.email);
